export default __webpack_public_path__ + "static/media/miguel-lopes-15.0e1c2bcc.jpg";